// extracted by mini-css-extract-plugin
export var container = "_bp-1";
export var cornerButtonContainer = "_bp-5";
export var disabled = "_bp-2";
export var fileContainer = "_bp-4";
export var hiddenInput = "_bp-3";
export var widthContainer = "_bp-0";